<div class="tfa">

    <!-- Header -->
    <div class="tfa__head">
        <div class="tfa__head-text">
            <h2 class="tfa__title">Two-factor authentication</h2>
            <span class="tfa__subtitle">Confirm this action with a code</span>
        </div>
        <button type="button" class="tfa__close" (click)="cancel()" aria-label="Close">
            <mat-icon svgIcon="close" class="!w-[15px] !h-[15px]"></mat-icon>
        </button>
    </div>

    <!-- Body -->
    <div class="tfa__body">
        <p class="tfa__text">Enter the code from Google Authenticator to confirm this action.</p>
        <app-otp-input
            [(ngModel)]="code"
            [length]="6"
            [bordered]="true"
            [autoSubmit]="true"
            [autoFocus]="true"
            [error]="!!data.error"
            (complete)="onComplete($event)">
        </app-otp-input>
        @if (data.error) {
            <span class="tfa__error">Invalid or expired code. Try again.</span>
        }
    </div>

    <!-- Footer -->
    <div class="tfa__footer">
        <button type="button" (click)="cancel()" mat-stroked-button class="tfa__btn-cancel">
            Cancel
        </button>
        <button type="button" [disabled]="code.length < 6" (click)="confirm()" mat-raised-button class="tfa__btn-save">
            Confirm
        </button>
    </div>
</div>
